import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

export default class extends Controller {
  static get targets() { return ["product"]; }

  add(event) {
    event.preventDefault();
    // Read off the event synchronously - currentTarget is nulled once the handler returns.
    const { url, id } = event.currentTarget.dataset;

    fetch(url, RequestHelper.defaultPostOptions()).
      then(response => {
        if (!response.ok) { throw new Error(`Add product failed (${response.status})`); }
        return response.text();
      }).
      then(html => {
        // url is admin_gallery_products_path built in the view, so this is always a same-origin
        // POST; the response is the server-rendered product_row partial, not user input.
        this.productTargets.find(row => row.dataset.id === id).outerHTML = html;
      }).
      catch(this.logFailedCall);
  }

  logFailedCall(response) {
    console.warn(response);
  }
}
